<template>
  <div class="col-12 page_content_area promotion_links_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <navigation
            :list="tags"
            :active-value="activeTag"
            variety="segmented"
            @active:updated="updateActiveTag"
          />
        </div>
      </div>
      <div class="row promotion_links_block">
        <div
          v-for="link in linksGetter"
          :key="link.link_id"
          class="col-12 col-sm-6 col-md-4 col-lg-3"
        >
          <a
            v-if="link.link_id"
            class="promotion_links_item"
            :href="link.link_url"
            :style="`background-image: url('${link.link_image}')`"
          />
        </div>
      </div>
      <div class="row justify-content-center">
        <bootstrap-pagination
          v-if="pageGetter.page_total > 1"
          :total-page-number="pageGetter.page_total"
          @number:updated="updateNewsPage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Navigation from '~components/common/Navigation'
import BootstrapPagination from '~bootstrap/Pagination'
export default {
  name: 'PromotionLinksContent',
  components: {
    BootstrapPagination,
    Navigation
  },
  data () {
    return {
      activeTag: this.$route.query.tag || '全部',
      tags: ['全部', 'NTUST', '人力銀行', '就業資訊', '國家考試', '留學資訊']
    }
  },
  computed: {
    ...mapGetters('pages/promotion-links', [
      'linksGetter',
      'pageGetter'
    ])
  },
  async created () {
    this.getLinksByType()
  },
  methods: {
    ...mapActions('pages/promotion-links', [
      'getLinksByType'
    ]),
    updateActiveTag (tag) {
      this.activeTag = tag
      this.$router.push({
        path: '/promotion-links',
        query: {
          tag: tag
        }
      })
      this.getLinksByType({
        type: this.tags.indexOf(this.activeTag) || null,
        page: 1
      })
    },
    updateNewsPage (page) {
      const params = { page }
      if (this.tags.indexOf(this.activeTag) > 0) {
        params.type = this.tags.indexOf(this.activeTag) || null
      }
      this.getLinksByType(params)
    }
  }

}
</script>
